import {
  Settings as SettingsIcon,
  Work as WorkIcon,
  MonetizationOn as PayrollIcon,
  PersonAdd as HiringIcon,
  BarChart as AnalyticsIcon,
  Help as HelpdeskIcon,
  LocationOn as GPSIcon,
  Policy as PolicyIcon,
  Feedback as FeedbackIcon,
} from "@mui/icons-material";

const navGroups = [
  // =================================================
  // CORE OPERATIONS
  // =================================================
  {
    title: "People Operations",
    groupIcon: WorkIcon,
    path: "/admin/people-operations",
  },

  {
    title: "Payroll & Finance",
    groupIcon: PayrollIcon,
    path: "/admin/payroll-dashboard",
  },

  {
    title: "Administration",
    groupIcon: SettingsIcon,
    path: "/admin/administration",
  },

  // =================================================
  // TALENT
  // =================================================
  {
    title: " Recruitment",
    groupIcon: HiringIcon,
    path: "/admin/hiring-recruitment",
  },

  {
    title: "Interview Feedback",
    groupIcon: FeedbackIcon,
    path: "/admin/interview-feedback",
  },

  {
    title: "Learning Hub",
    groupIcon: AnalyticsIcon,
    path: "/admin/performance-learning",
  },

  // =================================================
  // SUPPORT & OPERATIONS
  // =================================================
  {
    title: "CRM",
    groupIcon: WorkIcon,
    path: "/admin/crm",
  },

  {
    title: "Live Tracking",
    groupIcon: GPSIcon,
    path: "/admin/live-tracking-dashboard",
  },

  // =================================================
  // GOVERNANCE & INSIGHTS
  // =================================================
  {
    title: "Policies",
    groupIcon: PolicyIcon,
    path: "/admin/policy-dashboard",
  },

  {
    title: "Reports",
    groupIcon: AnalyticsIcon,
    path: "/admin/reports-insights",
  },
];

export default navGroups;
